export const emailReg =
  /^[A-Za-z0-9\u4e00-\u9fa5_!#$%&’*+/=?`{|}~^.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
